export default __webpack_public_path__ + "static/Ogg-Roman-106ff4f27988b2478ff3c0a881c591ae.otf";